import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { TemplateMedicineService } from 'src/app/shared/services/API/pharmacy/template-medicine.service';

@Component({
  selector: 'app-template-medicine-delete-modal',
  templateUrl: './template-medicine-delete-modal.component.html',
  styleUrls: ['./template-medicine-delete-modal.component.css']
})
export class TemplateMedicineDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    public matDialogRef: MatDialogRef<TemplateMedicineDeleteModalComponent>,
    private templateMedicineService: TemplateMedicineService,
    private alertService: AlertService,
  ) { }

  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({deleteTemplateMedicine: false}); 
  }
  
  clickDelete(){
    
    this.isLoading = true;

    this.templateMedicineService.delete(this.data.idTemplateMedicine).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.alertService.show('Sucesso', "Medicação excluída com sucesso!", AlertType.success); 
      this.matDialogRef.close({deleteTemplateMedicine: true}); 
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
  
  clickCancel(){
    this.matDialogRef.close({deleteTemplateMedicine: false}); 
  }
}